import React from "react";

const NAVY = "#1e3a8a";
const TEAL = "#00c9a7";

export default function SignupSuccessPage() {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: `linear-gradient(135deg, ${NAVY} 0%, #0f172a 100%)`,
      fontFamily: "var(--font-sans)", padding: 16,
    }}>
      <div style={{
        background: "white", borderRadius: 20, padding: "48px 40px", textAlign: "center",
        boxShadow: "0 25px 50px rgba(0,0,0,0.3)", width: "min(440px, calc(100vw - 32px))",
      }}>
        <div style={{ fontSize: 60, marginBottom: 16 }}>🎉</div>

        <h1 style={{ color: NAVY, fontSize: 24, fontWeight: 800, margin: "0 0 12px" }}>
          Payment confirmed!
        </h1>

        <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.7, margin: "0 0 24px" }}>
          Your workspace is being set up. Check your email — we've sent you a
          <strong> one-click setup link</strong> to access it.
        </p>

        <div style={{
          background: "#f0fdf4", border: "1px solid #bbf7d0",
          borderRadius: 10, padding: "14px 16px", marginBottom: 28,
          fontSize: 13, color: "#166534", lineHeight: 1.6,
        }}>
          Didn't receive the email? Check your spam folder, or{" "}
          <a href="/signup" style={{ color: TEAL, fontWeight: 600, textDecoration: "none" }}>
            contact support
          </a>.
        </div>

        <a href="/login" style={{
          display: "block", padding: "12px 0", borderRadius: 10,
          background: `linear-gradient(135deg, ${NAVY}, ${TEAL})`,
          color: "white", fontSize: 14, fontWeight: 700, textDecoration: "none",
        }}>
          Go to login →
        </a>
      </div>
    </div>
  );
}
